import { IResource } from "../i18n";

// tslint:disable-next-line: variable-name
const translation_en: IResource = {
    feedback_button_text: "Send",
    feedback_cta_0_3: "We are really sorry, please tell us what we should fix",
    feedback_cta_4_6: "That's a bummer, will you tell us what to improve?",
    feedback_cta_7_8: "What can we do to make it better?",
    feedback_cta_9_10: "Fantastic! Can you tell us the one thing you liked the most?",
    feedback_mail_subject: "Meet application feedback",
    feedback_text_legend: "We are equally grateful for both negative and positive feedback",
    feedback_text_title: "Provide your feedback here (optional)",
    feedback_title_finished: "Your Meet has finished",
    feedback_title_ongoing: "Please help us improve Meet",
    feedback_title_question: "How likely are you to recommend Meet to a friend or colleague?",
    feedback_value_best: "Very likely",
    feedback_value_worst: "Not likely at all",

    onboarding_button_jointext: "Join Meet",
    onboarding_description_four: "Button.",
    onboarding_description_one: "As a first time user, you can customize how others will see you in this Meet.",
    onboarding_description_three: "JOIN MEET",
    onboarding_description_two: "Once ready, just click ",
    onboarding_label_color: "Color",
    onboarding_label_consentAgree: "I agree with Meet’s",
    onboarding_label_consentPrivacy: "Privacy Policy",
    onboarding_label_consentAnd: "and",
    onboarding_label_consentTermsOfUse: "Terms of Use",
    onboarding_label_darkTheme: "Dark theme",
    onboarding_label_firstName: "Your name (optional)",
    onboarding_label_green: "Green",
    onboarding_label_indigo: "Indigo",
    onboarding_label_lastName: "Your last name (optional)",
    onboarding_label_lightTheme: "Light theme",
    onboarding_label_orange: "Orange",
    onboarding_label_pink: "Pink",
    onboarding_label_purple: "Purple",
    onboarding_label_teal: "Teal",
    onboarding_label_theme: "Theme",
    onboarding_label_yellow: "Yellow",
    onboarding_title: "Nice to Meet you!",

    invite_legend_text: "Send this link to a person who you want on the call",
    invite_link_copy: "Copy link",
    invite_link_defaultCopied: "Link copied to clipboard!",
    invite_link_email: "Email invite",
    invite_link_label: "Your invitation url",
    invite_link_sms: "SMS invite",
    invite_mail_body: "Hi, please join my Meet!",
    invite_mail_signature: "Regards",
    invite_mail_subject: "Your Meet join link",
    invite_title_text: "INVITE SOMEONE TO YOUR MEET",

    citypicker_label: "City",
    citypicker_nomatch: "No matching locations",

    userprofile_city_label: "City",
    userprofile_color_label: "Color",
    userprofile_email_label: "Email address",
    userprofile_label_green: "Green",
    userprofile_label_indigo: "Indigo",
    userprofile_label_orange: "Orange",
    userprofile_label_pink: "Pink",
    userprofile_label_purple: "Purple",
    userprofile_label_teal: "Teal",
    userprofile_label_yellow: "Yellow",
    userprofile_locale_label: "Language",
    userprofile_name_label: "First name",
    userprofile_surname_label: "Last name",
    userprofile_theme_label: "Theme",
    userprofile_themedark_label: "Dark theme",
    userprofile_themelight_label: "Light theme",

    options_tab_profile: "User Profile",

    consentdialog_button_cancel: "Cancel",
    consentdialog_button_ok: "OK",

    layout_meet_end: "End Meet",
    layout_meet_leave: "Leave Meet",

    layout_sidebar_labelClose: "Close sidebar menu",
    layout_sidebar_labelOpen: "Open sidebar menu",
    layout_sidebar_labelTitle: "Open sidebar menu",
    layout_title_text: "Meet | Frictionless interviews",

    layout_toolbar_enter: "Enter fullscreen",
    layout_toolbar_invite: "Invite",
    layout_toolbar_invite_tooltip: "Invite other people to this Meet",
    layout_toolbar_leave: "Leave fullscreen",

    layout_dialog_descriptionEnd: "This will end the Meet for all of the participants",
    layout_dialog_titleEnd: "Are you sure you want to end this Meet?",
    layout_dialog_titleLeave: "Are you sure you want to leave this Meet?",

    layout_dialog_descriptionLeave: "This will NOT end Meet for other participants",
    layout_sidebar_explorer: "Help",
    layout_sidebar_feedback: "Share feedback",
    layout_sidebar_settings: "Settings",

    layout_finish_endmeet: "End the current meeting",
    layout_finish_leavemeet: "Leave the current meeting",

    layout_cta_register: "Need a 60 min free Meet?",
    layout_cta_register_tooltip: "Sign up for a free 10$ credit",

    layout_dialog_descriptionAbandon: "It looks like you are the only one on the call",
    layout_dialog_titleAbandon: "Would you want to end this Meet?",

    language_en_title: "English",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_es_title: "Español",
    language_de_title: "Deutsche",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    meeting_finished_title: "FINISHED MEETING",
    meeting_finished_tooltip: "Read-only access",

    layout_reactivate_button: "Reactivate Meet",
    layout_reactivate_tooltip: "Click here if you want to reopen and use this finished Meet",
    layout_dialog_titleReactivate: "Are you sure you want to reactivate this Meet?",
    layout_dialog_descriptionReactivate: "This will re-open the Meet for joining, editing and other modifications",

    toast_reconnecting_title: "Calling signaling problem",
    toast_reconnecting_message: "Connection (state:{state}) lost due to error {error}. Reconnecting...",
    toast_reconnected_title: "Calling signaling",
    toast_reconnected_message: "Connection reestablished. State: {state}",
    toast_disconnected_title: "Calling signaling error",
    toast_disconnected_message: "Connection (state: {state}) closed due to error {error}." +
                                "Try refreshing this page to restart the connection.",

    config_title_text: "Create new Meet",
    config_title_ctaOne: "Please define the elements of a new Meet you want to create.",
    config_title_ctaTwo: "All of the input data is optional and can be omitted.",
    config_title_label: "Title",
    config_description_label: "Description",
    config_duration_label: "Duration",
    config_tool_label: "Meet tools",
    config_tool_call: "Meet video call",
    config_tool_editor: "Code editor",
    config_tool_whiteboard: "Whiteboard",
    config_passcode_label: "Meet passcode (if any)",

    search_placeholder_text: "Enter search criteria",
    createMeeting_button_create: "Create Meet",

    projectboard_scheduleinfo_none: "Meeting has no start date defined so it can be used anytime",
    projectboard_scheduleinfo_anytime: "anytime",

    projectboard_join_anyone: "Anyone with a link can join",
    projectboard_role_guest: "Guest",
    projectboard_role_interviewee: "Candidate",
    projectboard_role_interviewer: "Interviewer",
    projectboard_role_organizer: "Organizer",

    projectboard_status_draft: "In draft",
    projectboard_status_scheduling: "Scheduling",
    projectboard_status_schedulingFailed: "Scheduling failed",
    projectboard_status_pending: "Pending",
    projectboard_status_ready: "Ready",
    projectboard_status_starting: "Starting",
    projectboard_status_inprogress: "In progress",
    projectboard_status_onhold: "On hold",
    projectboard_status_stopped: "Stopped",
    projectboard_status_completed: "Completed",
    projectboard_status_canceled: "Canceled",
    projectboard_status_archived: "Archived",
    projectboard_status_feedbackWait: "Waiting for feedback",
    projectboard_status_feedbackDone: "Feedback collected",
    projectboard_status_feedbackFail: "Feedback collection failed",

    minibar_dashboard_title: "Dashboard",

    layout_sidebar_rateus: "Rate us",

    invite_passcode_label: "Passcode",
        
    invite_text_copy: "Copy invite",

    invite_text_body: "Please join my Meet at {url}",
    
    invite_passcode_body: "Please join my Meet at {url} and use passcode {passcode}",

    invite_text_copied: "Meet invite text is copied to clipboard.",

    invite_pascode_add: "Add passcode to url",

    participant_join_message: "{participant} had joined the meeting.",
    participant_left_message: "{participant} had left the meeting.",

    minibar_dashboard_tooltip: "Manage your interviews",

    layout_sidebar_snapshot: "Snapshots",

    snapshots_cta_text: "Take snapshot (F9)",
    

    snapshots_none_text: "Take one or more snapshots of the code editor and whiteboard and review them after the Meet.",
    snapshot_toast_text: "Snapshot taken",
    snapshot_sentiment_positive: "Positive snapshot",
    snapshot_sentiment_negative: "Negative snapshot",
    snapshot_sentiment_note: "Note",

    snapshot_personal_value: "Personal snapshot",
    snapshot_personal_title: "Visible only to you",
    snapshot_team_value: "Team snapshot",
    snapshot_team_title: "Visible only to your team.",
    snapshot_public_title: "Visible to all participants",
    snapshot_public_value: "Public snapshot",

    snapshots_live_text: "Go back to live Meet",

    snapshot_action_delete: "Delete",
    snapshot_action_load: "Load snapshot",

    snapshot_delete_dialog_title: "Delete snapshot?",
    snapshot_delete_dialog_description: "Please confirm that you want to delete this snapshot",

    snapshots_final_back: "Go back to Meet end state",
};

export default translation_en;
